<template>
    <v-dialog
        v-model="$store.state.demurrage.dialog"
        transition="dialog-bottom-transition"
        overlay-color="accent"
        width="500"
    >
        <v-card>
            <v-toolbar dark color="secondary" dense class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title> Add Demurrage </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.demurrage.dialog = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row class="mt-2">
                    <v-col class="text-center">
                        ShiftDetail: {{ dmData.shift }}
                    </v-col>
                    <v-col class="text-center">
                        Order: {{ dmData.orderID }}
                    </v-col>
                </v-row>
                <v-form ref="formSearch" lazy-validation>
                    <v-row cols="12">
                        <v-col cols="12">
                            <v-combobox
                                v-model="trantype"
                                :items="trantypes"
                                :item-text="'TranType'"
                                :item-value="'TranTypeId'"
                                label="Select Transaction Type"
                                :rules="[v => !!v || 'Required']"
                                required
                                auto-select-first
                            ></v-combobox>
                        </v-col>
                    </v-row>

                    <v-row style="margin-top: 0px; border-top: 0px">
                        <v-col>
                            <v-text-field
                                name="hours"
                                label="Hours"
                                v-model="qty"
                                type="number"
                                :rules="[v => !!v || 'Required']"
                                required
                                @input="calculateAmount"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                name="Rate"
                                label="Rate"
                                v-model="rate"
                                type="number"
                                :rules="[v => !!v || 'Required']"
                                required
                                @input="calculateAmount"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                name="Amount"
                                label="Amount"
                                v-model="amount"
                                type="number"
                                disabled
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-textarea
                                outlined
                                placeholder="..."
                                auto-grow
                                v-model="comment"
                                label="Comments"
                            ></v-textarea
                        ></v-col>
                    </v-row>

                    <v-row>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            class="my-5 mx-5"
                            @click="validateFormSearch"
                            >Add</v-btn
                        >
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    props: ['dmData'],
    data: function() {
        return {
            orderID: 9,
            trantype: [],
            rate: '',
            amount: '',
            trantypes: [],
            valid: true,
            qty: '',
            shift: [],
            comment: ''
        };
    },
    mounted() {
        this.loadTrasPay();
    },
    methods: {
        validateFormSearch() {
            if (this.$refs.formSearch.validate()) {
                this.addDemurrage();
            }
        },

        loadTrasPay: function() {
            var str = this.$store;
            axios
                .get('tran-type/extraPay', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.trantypes = response.data;
                    console.log(this.trantypes);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        calculateAmount: function() {
            this.amount = parseFloat(
                parseFloat(this.qty) * parseFloat(this.rate)*-1
            ).toFixed(2);
            if(this.amount > 0) {
                this.amount = this.amount * -1;
            }
        },
        addDemurrage: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            var parms = {
                TranType: this.trantype.TranTypeId,
                ShiftDetail: parseInt(this.dmData.shift),
                OrderNumber: this.dmData.orderID,
                Quantity: parseFloat(this.qty),
                Rate: parseFloat(this.rate),
                Amount: this.amount,
                TranDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                Description: this.comment
            };
            console.log(parms);
            axios
                .post('transaction', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New Transaction successfully'
                    });
                    str.state.demurrage.dialog = false;
                    str.state.posting.watch = true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        }
    }
};
</script>
